import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <img src="/logo.png" alt="HearMenders logo" />
          <h4>Better Hearing. Made More Accessible.</h4>
          <p>
            HearMenders connects people to professional hearing care, hearing aids,
            flexible payment options and ongoing support.
          </p>
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/services">Services</Link>
          <Link to="/financing">Financing</Link>
          <Link to="/financing#faq">FAQs</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-legal">
          <h4>Legal</h4>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-use">Terms of Use</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} HearMenders. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
